export const generateBounds = (mapCenterLocation) => {
  const [lat, lng] = mapCenterLocation;

  return {
    north: lat + 1,
    south: lat - 1,
    west: lng - 1,
    east: lng + 1
  };
};
